import { styled, css } from '@creditas-ui/system';
import { selectTheme } from '@creditas-ui/utilities';

const AsideExpanded = ({ expanded = false }: { expanded?: boolean }) =>
  expanded &&
  css`
    width: 276px;
    min-width: 160px;
  `;

export const Aside = styled.aside`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  display: flex;
  width: 94px;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 56px 22px;
  z-index: 2;
  transition: width 0.1s ease-in-out;
  overflow: hidden;
  border-right: 1px solid ${selectTheme('colors.neutral.10')};
  background-color: ${selectTheme('colors.neutral.10')};
  box-sizing: border-box;
  ${AsideExpanded}
`;
